import { AuthorizationSet } from "../dto";
import { IDropdownItem } from "./common.models";

export const dateFormatSelectOptions: IDropdownItem[] = [
  {
    value: "DD/MM/YYYY",
    label: "DD/MM/YYYY",
  },
  {
    value: "DD/MM/YY",
    label: "DD/MM/YY",
  },
  {
    value: "MM/DD/YYYY",
    label: "MM/DD/YYYY",
  },
  {
    value: "MM/DD/YY",
    label: "MM/DD/YY",
  },
  {
    value: "MMM DD, YYYY",
    label: "Mon DD, YYYY",
  },
  {
    value: "DD MMMM, YYYY",
    label: "DD Month, YYYY",
  },
];

export const languageSelectOptions: IDropdownItem[] = [
  {
    value: "he",
    label: "עברית",
  },
  {
    value: "en",
    label: "English",
  },
];

export const timeFormatSelectOptions: IDropdownItem[] = [
  {
    value: "HH:mm", //24-hour format
    label: "HH:MM",
  },
  {
    value: "hh:mm A", //12-hour format, 2-digits AM/PM
    label: "HH:MM ZM",
  },
];

export interface IProfileListCompanyDto {
  id: number;
  title: string;
  authorizeSets: AuthorizationSet[];
}
